import React,{ Component } from 'react';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import { Row, Col } from 'react-bootstrap';
import { Typography, Button } from '@material-ui/core';
import { withRouter } from 'react-router';
import ReactCodeInput from 'react-verification-code-input';
import * as compose from 'lodash.flowright';

import './email-conf.style.css';
import Logo from '../../../images/logo.png';


class  EmailConf extends  Component{
    constructor(props){
        super(props);
        this.state = {
            email : this.props.email,
            to : this.props.to,
            code : '',
            errorMessage : '',
            from : this.props.location.state.from,
            inputreset : ''
        }
    }
    render(){
        const handelSubmit = (e) => {
            e.preventDefault();
            let inputs = document.querySelectorAll('input');
            let code = "";
            for(var x = 0; x < inputs.length; x++){
                code = code + inputs[x].value
            }
            if(code.length === 5){
                this.setState({...this.state , code: code})                           
                this.props.emailConfirmation({
                    variables : {
                        email : this.state.email,
                        pin_code : code
                    }
                }).then((res)=>{
                    if(res.data.verifyPinCode.Status.code === 200){
                        this.props.history.push({
                            pathname: this.state.to,
                            state: { 
                                email: this.state.email,
                                code : this.state.code
                             }
                        });
                    }
                    this.setState({ ...this.state,errorMessage:res.data.verifyPinCode.Status.message })
                })
                .catch((err)=> this.setState({...this.state, errorMessage : "Email is not valid"}));
            }else{
                this.setState({ ...this.state,errorMessage: "Please enter  valid pin code" })
            }}
        const resetForm =()=>{
            this.setState({ ...this.state, inputreset: "" })
             return true;
        }
     return (
            <div className="container-custom pt-10">
                <form 
                    id = "myForm"
                    onSubmit={handelSubmit}
                    className="container mb-5" autoComplete="off">
                    <div className="pt-1 pb-3">
                        <img src={Logo} alt="spreago logo" width="150px"/>
                    </div>
                    <div className="pb-1">
                        <Typography variant="h4" color="primary" >Email Confirmation</Typography>
                    </div>
                    <div className="pt-1 pb-3">
                     <Typography variant="subtitle1" className="text-dark">Please write down the 5 digit that was sent to {this.state.email}</Typography>
                    </div>
                    <Row className="text-center pt-3 customInput">
                        <Col md={12}>
                          <ReactCodeInput 
                            fields={5} 
                            fieldHeight={100} 
                            className="w-auto bg-light border-0  m-1" 
                            onComplete={()=>
                            {
                            let inputs = document.querySelectorAll('input');
                            let code = "";
                            for(var x = 0; x < inputs.length; x++){
                                code = code + inputs[x].value
                            }
                            if(code.length === 5){
                                this.setState({...this.state , code: code})                           
                                this.props.emailConfirmation({
                                    variables : {
                                        email : this.state.email,
                                        pin_code : code
                                    }
                                }).then((res)=>{
                                    if(res.data.verifyPinCode.Status.code === 200){
                                        this.props.history.push({
                                            pathname: this.state.to,
                                            state: { 
                                                email: this.state.email,
                                                code : this.state.code
                                            }
                                        });
                                    }
                                    this.setState({ ...this.state,errorMessage:res.data.verifyPinCode.Status.message })
                                })
                                .catch((err)=> this.setState({...this.state, errorMessage : "Email is not valid"}));
                            }}}
                          />
                        </Col>
                        <Col><div className="text-danger text-center"><p>{this.state.errorMessage}</p></div></Col>
                    </Row>
                    <Row className="pt-3">
                        <Col xs={12} className="text-center">
                            <Button size="large" type="submit" className="btn-orange-gradiant pr-5 pl-5" variant="contained" color="primary"><Typography>Next</Typography></Button>
                        </Col>
                        <Col xs={12} className="text-center pt-1">
                            <Typography variant="subtitle1" className="text-dark"> Didn't receive the email? 
                            <Button  size="large"
                            onClick={e => {
                                if(resetForm()){
                                    if(this.state.from === '/forgetPassword'){
                                        this.props.sendCodeForReset({
                                            variables : {
                                                email : this.state.email,
                                            }
                                        }).then((res)=>{
                                            if(res.data.sendPinCodeForpasswordresets.Status.code === 200){
                                                this.setState({...this.state, errorMessage : res.data.sendPinCodeForpasswordresets.Status.message})
                                            }
                                        })
                                        .catch((err)=> console.log(err));
                                    }
                                    else {     
                                        this.props.sendPinCodeForRegister({
                                            variables : {
                                                email : this.state.email,
                                            }
                                        }).then((res)=>{
                                            if(res.data.sendPinCodeForRegister.Status.code === 200){
                                                this.setState({...this.state, errorMessage : res.data.sendPinCodeForRegister.Status.message})
                                            }
                                        })
                                        .catch((err)=> this.setState({...this.state, errorMessage : "Check your internet connection" }));
                                        }
                                    }
                                }} 
                             className="text-orange"> Resend now !</Button></Typography>
                        </Col>
                    </Row>

                </form>
            </div>
        );  
    }
}
const EMAIL_CONFIRMATION = gql`
mutation($email : Email ! $pin_code : String !){
    verifyPinCode(data: {
      email : $email
      pin_code : $pin_code
    }){
      Status{
        message
        code
      }
    }
  }
`;
const SEND_CODE_FOR_RESET = gql`
mutation( $email : Email! ){
    sendPinCodeForpasswordresets(email: $email){
      Status{
        code
        message
      }
    }
  }
`;
const SEND_CODE_FOR_REGISTER = gql`
mutation( $email : Email! ){
    sendPinCodeForRegister(email: $email){
      Status{
        code
        message
      }
    }
  }
`;

export default  compose(
    graphql(EMAIL_CONFIRMATION, {
    name : 'emailConfirmation'
  }),
    graphql(SEND_CODE_FOR_RESET, {
    name: 'sendCodeForReset'
  }),
  graphql(SEND_CODE_FOR_REGISTER, {
    name: 'sendPinCodeForRegister'
  })
)(withRouter(EmailConf));